<template>
    <div>
        <EditUser/>
    </div>
</template>

<script>
import EditUser from '../components/EditUser.vue';
export default {
    components: {
        EditUser
    }
};
</script>